import React from 'react';
import Profile from '../Profile';

/**
 * Account Settings for the Court Admin portal.
 * Reuses the shared MatDash Profile page (same look as Registrar / Super Admin).
 */
const AdminAccountSettings = () => <Profile />;

export default AdminAccountSettings;
